import { useContext } from 'react'
import { appendReturnTo } from '@/lib/links'
import {
  AnalyticsContext,
  AuthContext,
  DocsBaseUrlContext,
  SignupUrlContext,
  SurfaceContext,
} from './context'
import type {
  TrackerAnalytics,
  TrackerAuth,
  TrackerSurface,
} from './TrackerProvider.types'

export function useAuth(): TrackerAuth {
  return useContext(AuthContext)
}

export function useAnalytics(): TrackerAnalytics {
  return useContext(AnalyticsContext)
}

// The signup/conversion target for gated/anonymous CTAs, injected per shell
// (defaults to VWAM_SIGNUP_URL via the context default).
export function useSignupUrl(): string {
  const signupUrl = useContext(SignupUrlContext)

  return appendReturnTo(signupUrl, '/tracker')
}

export function useSurface(): TrackerSurface {
  return useContext(SurfaceContext)
}

export function useDocsBaseUrl(): string {
  return useContext(DocsBaseUrlContext)
}
